import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Radio, FormGroup, ControlLabel } from 'react-bootstrap';
import _ from 'underscore';
import GoogleMapReact from 'google-map-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, Button, } from '@cargomatic/ui';
class DuplicateLocationModal extends Component {
    constructor(props) {
        super(props);
        this.handleMapChange = ({ /* center, bounds, marginBounds, */ size, zoom }) => {
            if (this.state.size !== size)
                this.setState({ size });
            this.setState({ zoom });
        };
        this.handleSubmit = () => {
            const duplicateAddress = this.props.addresses.filter((location) => {
                return location.coords === this.state.selectedAddress;
            });
            this.props.onSelectLocation(_.first(duplicateAddress));
        };
        this.handleLocationSelect = (coords) => {
            this.setState({ selectedAddress: coords });
        };
        const address = _.first(props.addresses);
        this.state = {
            selectedAddress: address.coords,
            zoom: 10,
            center: {
                lat: address.lat,
                lng: address.lng,
            },
        };
    }
    render() {
        const { addresses } = this.props;
        if (!addresses) {
            return null;
        }
        const Marker = ({ text }) => {
            return (React.createElement("div", { style: { width: 20, height: 20 } },
                React.createElement("i", { className: "icon-location marker", style: { color: '#21b88e', fontSize: '24px' } }),
                React.createElement("div", { style: {
                        marginLeft: '9px',
                        color: 'black',
                        borderRadius: '50%',
                        fontSize: '14px',
                        paddingLeft: '4px',
                    } }, text)));
        };
        const markers = addresses.map((address, index) => {
            return (React.createElement(Marker, { lat: address.lat, lng: address.lng, key: index, text: index + 1 }));
        });
        const locationRadioButtons = (React.createElement(FormGroup, { controlId: "location_select" },
            React.createElement(ControlLabel, null, "Select an Address"),
            addresses.map((add, index) => {
                const number = index + 1;
                return (React.createElement(Radio, { name: "location_select", value: add.coords, checked: this.state.selectedAddress &&
                        this.state.selectedAddress === add.coords, onChange: () => this.handleLocationSelect(add.coords) }, `${number}. ${add.lat}, ${add.lng}`));
            })));
        return (React.createElement(Dialog, { open: this.props.show, onOpenChange: this.props.onHide, className: "z-[999999]" },
            React.createElement(DialogContent, { className: "sm:max-w-[1080px]" },
                React.createElement(DialogHeader, null,
                    React.createElement(DialogTitle, null, `Select Address - ${addresses[0].address}`)),
                React.createElement("div", { className: "flex", style: { height: '400px', width: '880px' } },
                    React.createElement("div", { className: "col-md-6" },
                        React.createElement("p", null, "Multiple Locations were found with this address. Please select the correct one."),
                        React.createElement("div", null, locationRadioButtons)),
                    React.createElement("div", { className: "col-md-6" },
                        React.createElement("div", { style: { width: 400, height: 300 } }, markers && (React.createElement(GoogleMapReact, { bootstrapURLKeys: {
                                key: GOOGLE_MAPS_KEY,
                                language: 'en',
                            }, defaultCenter: this.state.center, defaultZoom: this.state.zoom }, markers))))),
                React.createElement(DialogFooter, null,
                    React.createElement(Button, { variant: "outline", onClick: this.props.onHide, className: "mr-2" }, "Cancel"),
                    React.createElement(Button, { onClick: this.handleSubmit, disabled: !this.state.selectedAddress, style: { background: '#21b88e' } }, "Submit")))));
    }
}
DuplicateLocationModal.propTypes = {
    addresses: PropTypes.array.isRequired,
    onSelectLocation: PropTypes.func.isRequired,
    show: PropTypes.func,
    onHide: PropTypes.func,
};
export default DuplicateLocationModal;
